import { SAVE_QUIK_KEY, ADD_OPTION_CHAIN_INSTRUMENTS,SAVE_STRIKE_DATA, SAVE_INSTRUMENT_EXPIRY, SAVE_INSTRUMENT_SPOT_PRICE, SAVE_OP_TICK_DATA,SAVE_SYN_FUT_PRICE, SAVE_FUT_PRICE, SAVE_SYN_FUT_TOKEN, SAVE_MIDDLE_STRIKE } from '../../util/actionTypes';
const initialState = {quikKeys:{},data:{},strikeData:{},expiry:{}, spotPrice:0, tickData:{},synFut:0, futPrice:0,synFutToken:{},middleStrike:0};

const optionChainReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case ADD_OPTION_CHAIN_INSTRUMENTS: 
            return {
                ...state,
                data :action.payload, 
            }; 
        case SAVE_STRIKE_DATA: 
            return {
                ...state,
                strikeData :action.payload, 
         };
         
        case SAVE_INSTRUMENT_EXPIRY: 
            return {
                ...state,
                expiry :action.payload, 
        };

        case SAVE_INSTRUMENT_SPOT_PRICE: 
        return {
                ...state,
                spotPrice :action.payload, 
        };     
        case SAVE_OP_TICK_DATA: 
        return {
                ...state,
                tickData :action.payload, 
        };     
  
        case SAVE_SYN_FUT_PRICE: 
        return {
                ...state,
                synFut :action.payload, 
        };     
  

        case SAVE_FUT_PRICE: 
        return {
                ...state,
                futPrice :action.payload, 
        }; 

        case SAVE_SYN_FUT_TOKEN: 
        return {
                ...state,
                synFutToken :action.payload, 
        };  

        case SAVE_MIDDLE_STRIKE: 
        return {
                ...state,
                middleStrike :action.payload, 
        };
        case SAVE_QUIK_KEY: 
        return {
            ...state,
            quikKeys :action.payload, 
        }; 
        default:
            return state;
    }
};

export default optionChainReducer;
